// extracted by mini-css-extract-plugin
export default {"auth-button":"AuthHeader_auth-button__FKdcC"};